import request from '@/utils/request'

// 获取列表
export function getBillList(params) {
    return request({
        url: '/agent/order/agentAccountRecord',
        method: 'get',
        params,
    })
}

// 获取账单详情
export function getBillDetail(id) {
    return request({
        url: `/agent/order/powerBankTransOrder/${id}`,
        method: 'get',
    })
}



// WEBPACK FOOTER //
// ./src/api/bill.js